import { CreatePricelistPlatformOperatorRequestDTO, PricelistResponseDTO } from 'typings/dto/pricelist';
import ModelActionsService from '../ModelActionsService';
import IPricelistPlatformOperatorActionsService from './IPricelistPlatformOperatorActionService';

export default class PricelistPlatformOperatorActionsServiceImpl
  extends ModelActionsService<Pricelist.PlatformOperator, CreatePricelistPlatformOperatorRequestDTO, PricelistResponseDTO.PlatformOperator>
  implements IPricelistPlatformOperatorActionsService {}
